/** @format */

import DashboardCard from "./DashboardCard";
import { HiMiniSignal } from "react-icons/hi2";
import { useSelector } from "react-redux";
import SignalsLoader from "./latest-signals/SignalsLoader";
import { useState } from "react";
import styles from "../../styles/Components/new-dashboard/LatestSignals.module.css";
import { FaArrowRight, FaListUl } from "react-icons/fa6";
import { BsFillGrid3X3GapFill } from "react-icons/bs";
import SignalsList from "./latest-signals/SignalsList";
import SignalPreview from "./latest-signals/SignalPreview";
import CustomButton from "../../ui/CustomButton";
import { useNavigate } from "react-router-dom";
import LiveAIButton from "./LiveAIButton";
import useFetchSignalInfo from "../../hooks/api/useFetchSignalInfo";
import useDashboardSignalAutoRefresh from "../../hooks/api/useDashboardSignalAutoRefresh";
import useFetchWatchlists from "../../hooks/api/useFetchWatchlists";
import { Tooltip } from "antd";
import RefreshTimerBar from "./latest-signals/RefreshTimerBar";
import SignalIcon from "../../ui/icons/SignalIcon";

// Animation notification component
function AnimatedNotification() {
  const [isPulsing, setIsPulsing] = useState(true);

  return (
    <Tooltip
      title="New signals are generated every 5 minutes. Stay on this page to avoid missing out."
      color="#0c4cfc"
      placement="bottom"
    >
      <div
        className={styles.notificationIcon}
        onMouseEnter={() => setIsPulsing(false)}
        onMouseLeave={() => setIsPulsing(true)}
      >
        <span
          className={isPulsing ? styles.pulseAnimation : ""}
          style={{ marginTop: ".4rem" }}
        >
          <SignalIcon />
        </span>
        {/*<HiMiniSignal*/}
        {/*  size={18}*/}
        {/*  color="#fff"*/}
        {/*  className={isPulsing ? styles.pulseAnimation : ""}*/}
        {/*/>*/}
      </div>
    </Tooltip>
  );
}

function LatestSignals() {
  const {
    dashboard: { signalInfoStatus },
  } = useSelector((state) => state);

  const [display, setDisplay] = useState("card");

  const navigate = useNavigate();
  // fetch signal info at first render
  useFetchSignalInfo();
  // refresh signal info every 15min
  useDashboardSignalAutoRefresh();
  // fetch user's watchlist
  useFetchWatchlists();

  return (
    <DashboardCard
      title="Latest Signals"
      titleIcon={<HiMiniSignal />}
      preview={<SignalPreview />}
      type="latestSignals"
      actions={
        <>
          <AnimatedNotification />
          <LiveAIButton className={styles.liveAi} iconPosition="start" />
          <CustomButton
            type="primary"
            className={styles.liveAi}
            onClick={() => navigate("/ai-assistant")}
          >
            <FaArrowRight /> To AI Assistant
          </CustomButton>
        </>
      }
      id="latest-signals"
    >
      {signalInfoStatus === "success" && <RefreshTimerBar />}
      <div className={styles.viewToggle}>
        <span
          className={`${styles.toggleBtn} ${styles.secondary} ${
            display === "card" ? styles.selected : ""
          }`}
          onClick={() => setDisplay("card")}
        >
          <BsFillGrid3X3GapFill size={12} /> Card View
        </span>
        <span
          className={`${styles.toggleBtn} ${styles.secondary} ${
            display === "list" ? styles.selected : ""
          }`}
          onClick={() => setDisplay("list")}
        >
          <FaListUl size={12} /> List View
        </span>
      </div>

      {signalInfoStatus === "loading" && <SignalsLoader view={display} />}

      {signalInfoStatus === "success" && <SignalsList view={display} />}
    </DashboardCard>
  );
}

export default LatestSignals;
